import { useState } from "react";
import { DeleteIconButton } from "./DeleteIconButton";
import ConfirmDialog from "./ConfirmDialog";

interface DeleteButtonProps {
  /** Called when user confirms deletion. Should return a promise. */
  onDelete: () => Promise<void>;
  /** Called after successful deletion */
  onSuccess?: () => void;
  ariaLabel?: string;
  iconSize?: "sm" | "md" | "lg";
  /** Dialog title */
  title?: string;
  /** Dialog message */
  message?: string;
  /** Confirm button label */
  confirmLabel?: string;
  /** Loading confirm button label */
  confirmLoadingLabel?: string;
  /** Disabled state */
  disabled?: boolean;
}

export default function DeleteButton({
  onDelete,
  onSuccess,
  ariaLabel = "Excluir",
  iconSize = "sm",
  title = "Excluir",
  message = "Tem certeza que deseja excluir?",
  confirmLabel = "EXCLUIR",
  confirmLoadingLabel = "EXCLUINDO...",
  disabled = false,
}: DeleteButtonProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onDelete();
      setIsOpen(false);
      onSuccess?.();
    } catch (err) {
      console.error(err);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <>
      <DeleteIconButton
        onClick={() => setIsOpen(true)}
        aria-label={ariaLabel}
        iconSize={iconSize}
        disabled={disabled || isDeleting}
      />

      <ConfirmDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={title}
        message={message}
        confirmLabel={confirmLabel}
        confirmLoadingLabel={confirmLoadingLabel}
        onConfirm={handleConfirm}
        loading={isDeleting}
        destructive
      />
    </>
  );
}
